import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forEachChild } from 'typescript';
//import { parse } from 'url';
import { DbContextService } from '../../../services/db-context.service';
import { DataFormatter } from '../../common/dataFormatter';
import { Helper } from '../../common/helper';
import { OrderHeaderData } from '../model/order-header';
import { OrderListData } from '../model/order-list';
import { OrderInfoOverviewData } from '../model/order-overview';
import { OrderInfoDetailByCategory } from '../model/orderInfoDetailByCategory';
import { OrderInfoDetailByCategoryGroup } from '../model/orderInfoDetailByCategoryGroup';
import { OrderInfoDetailBySubCategory } from '../model/orderInfoDetailBySubCategory';
import { SecurityHelper } from '../../common/securityHelper';
import swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class OrderOverviewService {

  constructor(
    private http: HttpClient,
    private dbxService: DbContextService) { }

  getOrderInfoOverview() {

    return this.http.post(Helper.API_URL() + '/api/orders/GetOrderInfoOverview', {});
  }

  getOrderInfoOverviewDelivered() {

    return this.http.post(Helper.API_URL() + '/api/orders/GetOrderInfoOverviewDelivered', {});
  }

  markAsDelivered(orderInfoHeaderId: number) {

    let paramObject = {
      'page': Helper.Constants.DailyLogs.Forms.ORDER_OVERVIEW,
      'orderInfoHeaderID': orderInfoHeaderId,
      'orderStatusID': Helper.Constants.OrderStatusID.DELIVERED
    }

    return this.http.post(Helper.API_URL() + '/api/orders/ProcessUpdateOrderStatus', paramObject);
  }

  deleteOrderWSTemp(orderInfoHeaderId: number, createUserId: number) {
    let paramObject = {
      'orderInfoHeaderId': orderInfoHeaderId,
      'createUserId': createUserId,
    }
    return this.http.post(Helper.API_URL() + '/api/orders/DeleteOrderWSTemp', paramObject);
  }

  deleteIMIOrder(orderInfoHeaderID: number) {
    let paramObject = {
      'orderInfoHeaderID': orderInfoHeaderID,
    }
    return this.http.post(Helper.API_URL() + '/api/orders/DeleteIMIOrderInfoHeader', paramObject);
  }

  getOrderInfoOverviewIntoIndexDb() {
    this.getOrderInfoOverview().subscribe((res: any) => {
      if (res.errorMessage.length <= 0) {
        this.saveOpenOrderInfoOverviewIndxDb(res.entity.openOrderInfoOverviewList);
        this.saveSubmittedOrderInfoOverviewIndxDb(res.entity.submittedOrderInfoOverviewList);
        this.saveDeliveredOrderInfoOverviewIndxDb(res.entity.deliveredOrderInfoOverviewList);
      }
    });
  }

  //IndexDB functions ---------------------------------------------------------
  getOpenOrderInfoOverviewIndxDb(shipID: number, submitted: boolean): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      let openOrderInfoOverviewList: OrderInfoOverviewData[] = [];

      this.getTempOrderInfoOverviewIndxDb(submitted).then((orders: any) => {
        orders.forEach((order: OrderInfoOverviewData) => {
          openOrderInfoOverviewList.push(order);
        })

        let tempOpenList = Helper.deepCopy(openOrderInfoOverviewList);
        this.getDraftIndxDb(shipID, submitted).then((orders: any) => {
          orders.forEach((order: OrderInfoOverviewData) => {
            let exists = false;
            for (var i = 0; i < tempOpenList.length; i++) {
              if (tempOpenList[i].orderInfoHeaderID == order.orderInfoHeaderID) {
                exists = true;
                break;
              }
            }
            if (!exists) {
              openOrderInfoOverviewList.push(order);
            }
          });
          resolve(openOrderInfoOverviewList);
        })
      })
    })
    return promise;
  }

  getDraftIndxDb(shipID: number, submitted: boolean): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      let draftOrderList: OrderInfoOverviewData[] = [];

      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblOrderInfoHeader', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderInfoHeader');
        store.getAll().then(
          (res: OrderHeaderData[]) => {
            for (let i = 0; i < res.length; i++) {
              if (isNaN(Number(res[i].orderInfoHeaderID.toString()))) {
                if (res[i].shipID == shipID) {
                  //if ((submitted == true && res[i].statusID == null) || (submitted == false && res[i].statusID != null)) {
                  //  continue;
                  //}
                  let orderInfoOverview = this.toOrderInfoOverviewData(res[i]);

                  let dtx = db.transaction('OWS_tblOrderDetail', 'readwrite');
                  let dstore = dtx.objectStore('OWS_tblOrderDetail');
                  dstore.get(res[i].orderInfoHeaderID).then(
                    (resdet: any) => {
                      if (resdet != null) {
                        resdet.orderDetailList.forEach((orderCateryGroup: OrderInfoDetailByCategoryGroup) => {
                          orderCateryGroup.orderInfoDetailByCategory.forEach((orderCategory: OrderInfoDetailByCategory) => {
                            orderCategory.orderInfoDetailBySubCategory.forEach((orderSubCategory: OrderInfoDetailBySubCategory) => {
                              orderSubCategory.orderInfoDetail.forEach((item: OrderListData) => {
                                orderInfoOverview.productCount = orderInfoOverview.productCount + (item.orderQuantity > 0 ? 1 : 0);
                                orderInfoOverview.total = orderInfoOverview.total + (item.orderQuantity * item.orderPrice);
                              })
                            })
                          })
                        })
                      }
                    })
                  draftOrderList.push(orderInfoOverview);
                }
              }
            }
            resolve(draftOrderList);
          })
      });
    });
    return promise;
  }

  getTempOrderInfoOverviewIndxDb(approved: boolean): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        //get temp orders
        let tx = db.transaction('OWS_tblOrderOverviewOpen', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderOverviewOpen');
        store.getAll().then((res: OrderInfoOverviewData[]) => {
          let tempOrderInfoOverviewList: OrderInfoOverviewData[] = [];
          res.forEach((orderInfoOverview: OrderInfoOverviewData) => {
            if (orderInfoOverview.isTempDeleted == null || orderInfoOverview.isTempDeleted == false) {
              if (approved) {
                if (orderInfoOverview.isTempApproved != null || orderInfoOverview.isTempApproved == true) {
                  orderInfoOverview.orderInfoHeaderID += "-T";
                  orderInfoOverview.orderStatusID = Helper.Constants.OrderStatusID.NEW_ORDER;
                  orderInfoOverview.wsStatus = Helper.Constants.OrderStatusName.SUBMITTED;
                  orderInfoOverview.wsStatusDesc = Helper.Constants.OrderStatusDesc.SUBMITTED;
                  tempOrderInfoOverviewList.push(orderInfoOverview);
                }
              } else {
                if (orderInfoOverview.isTempApproved == null || orderInfoOverview.isTempApproved == false) {
                  orderInfoOverview.orderInfoHeaderID += "-T";
                  orderInfoOverview.orderStatusID = (!orderInfoOverview.isSubmittedFromIMI) ? Helper.Constants.OrderStatusID.FOR_REVIEW : Helper.Constants.OrderStatusID.FOR_REVIEW_FROM_IMI;
                  orderInfoOverview.wsStatus = (!orderInfoOverview.isSubmittedFromIMI) ? Helper.Constants.OrderStatusName.FOR_REVIEW : Helper.Constants.OrderStatusName.FOR_REVIEW_FROM_IMI;
                  orderInfoOverview.wsStatusDesc = (!orderInfoOverview.isSubmittedFromIMI) ? Helper.Constants.OrderStatusDesc.FOR_REVIEW : Helper.Constants.OrderStatusDesc.FOR_REVIEW_FROM_IMI;
                  tempOrderInfoOverviewList.push(orderInfoOverview);
                }
              }
            }
          })
          resolve(tempOrderInfoOverviewList);
        })
      })
    })
    return promise;
  }

  private toOrderInfoOverviewData(orderHeader: OrderHeaderData): OrderInfoOverviewData {
    let orderInfoOverview = new OrderInfoOverviewData();
    orderInfoOverview.orderInfoHeaderID = orderHeader.orderInfoHeaderID;
    orderInfoOverview.orderDate = orderHeader.orderDate;
    orderInfoOverview.deliveryDate = orderHeader.deliveryDate;
    orderInfoOverview.countryName = orderHeader.countryName;
    orderInfoOverview.harborName = orderHeader.harborName;
    orderInfoOverview.countryName = orderHeader.countryName;
    orderInfoOverview.departmentName = orderHeader.departmentName;
    orderInfoOverview.currencySymbol = orderHeader.supplierCurrencySymbol;
    orderInfoOverview.orderStatusID = orderHeader.statusID;
    orderInfoOverview.wsStatus = orderHeader.statusDesc;
    orderInfoOverview.isUpdatedOffline = orderHeader.isUpdateOffline;
    orderInfoOverview.productCount = 0;
    orderInfoOverview.total = 0;
    orderInfoOverview.skipCatalog = orderHeader.skipCatalog ? orderHeader.skipCatalog : false;
    return orderInfoOverview;
  }

  cancelOrderIndxDb(orderInfoHeaderID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      //delete from order header
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblOrderInfoHeader', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderInfoHeader');
        store.delete(orderInfoHeaderID);
      });

      //delete from order detail
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblOrderDetail', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderDetail');
        store.delete(orderInfoHeaderID);
      });

      resolve(orderInfoHeaderID);
    });
    return promise;
  }

  getSubmittedOrderInfoOverviewIndxDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      let list: OrderInfoOverviewData[] = [];

      this.getSubmittedPending().then((orders: any) => {
        orders.forEach((order: OrderInfoOverviewData) => {
          list.push(order);
        })

        this.getTempOrderInfoOverviewIndxDb(true).then((orders: any) => {
          orders.forEach((order: OrderInfoOverviewData) => {
            list.push(order);
          });

          resolve(list);
        })
      });
    });
    return promise;
  }

  getDeliveredOrderInfoOverviewIndxDb(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      let list: OrderInfoOverviewData[] = [];
      this.getSubmittedDeliveredOffline().then((orders: any) => {
        orders.forEach((order: OrderInfoOverviewData) => {
          list.push(order);
        });
        this.getDeliveredClosed().then((orders: any) => {
          orders.forEach((order: OrderInfoOverviewData) => {
            list.push(order);
          });
          resolve(list);
        });
      });
    });
    return promise;
  }

  private getSubmittedPending(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblOrderOverviewSubmitted', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderOverviewSubmitted');
        store.getAll().then(
          (res: OrderInfoOverviewData[]) => {
            let list: OrderInfoOverviewData[] = [];

            //get submitted not marked as delivered
            res.forEach((order: OrderInfoOverviewData) => {
              if ((order.isDelivered == null) || !order.isDelivered) {
                list.push(order);
              }
            });
            resolve(list);
          })
      });
    });
    return promise;
  }

  private getSubmittedDeliveredOffline(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblOrderOverviewSubmitted', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderOverviewSubmitted');
        store.getAll().then(
          (res: OrderInfoOverviewData[]) => {
            let list: OrderInfoOverviewData[] = [];

            //get submitted marked as delivered
            res.forEach((order: OrderInfoOverviewData) => {
              if ((order.isDelivered != null) && order.isDelivered) {
                list.push(order);
              }
            });
            resolve(list);
          })
      });
    });
    return promise;
  }

  private getDeliveredClosed(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblOrderOverviewDelivered', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderOverviewDelivered');
        store.getAll().then(
          (res: OrderInfoOverviewData[]) => {
            resolve(res);
          })
      });
    });
    return promise;
  }

  saveSubmittedOrderInfoOverviewIndxDb(orderList: OrderInfoOverviewData[]) {
    this.dbxService.openDatabase().then(db => {
      let tx = db.transaction('OWS_tblOrderOverviewSubmitted', 'readwrite');
      let store = tx.objectStore('OWS_tblOrderOverviewSubmitted');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      //delete order not marked as delivered
      store.getAll().then(
        (res: OrderInfoOverviewData[]) => {
          res.forEach((order: OrderInfoOverviewData) => {
            if (order.isDelivered == null || !order.isDelivered) {
              store.delete(order.orderInfoHeaderID);
            }
          });

          //add recently pulled orders from ifsobs
          orderList.forEach((order: OrderInfoOverviewData) => {
            store.get(order.orderInfoHeaderID).then((o: OrderInfoOverviewData) => {
              if (o == null) {
                try {
                  store.add(order);
                } catch (e: any) {
                  if (e?.name === 'QuotaExceededError') {
                    this.handleQuotaExceeded();
                  }
                }
              }
            });

          });
        });
    });
  }

  saveOpenOrderInfoOverviewIndxDb(orderList: OrderInfoOverviewData[]) {
    this.dbxService.openDatabase().then(db => {
      let tx = db.transaction('OWS_tblOrderOverviewOpen', 'readwrite');
      let store = tx.objectStore('OWS_tblOrderOverviewOpen');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      //delete order not marked as updated offline
      store.getAll().then(
        (res: OrderInfoOverviewData[]) => {
          res.forEach((order: OrderInfoOverviewData) => {
            if (order.isUpdatedOffline == null || !order.isUpdatedOffline) {
              store.delete(order.orderInfoHeaderID);
            }
          });

          //add recently pulled orders from ifsobs
          orderList.forEach((order: OrderInfoOverviewData) => {
            store.get(order.orderInfoHeaderID).then((o: OrderInfoOverviewData) => {
              if (o == null) {
                try {
                  store.add(order);
                } catch (e: any) {
                  if (e?.name === 'QuotaExceededError') {
                    this.handleQuotaExceeded();
                  }
                }
              } else {
                try {
                  store.put(order);
                } catch (e: any) {
                  if (e?.name === 'QuotaExceededError') {
                    this.handleQuotaExceeded();
                  }
                }
              }
            });

          });
        });
    });
  }

  saveDeliveredOrderInfoOverviewIndxDb(orderList: OrderInfoOverviewData[]) {
    this.dbxService.openDatabase().then(db => {
      let tx = db.transaction('OWS_tblOrderOverviewDelivered', 'readwrite');
      let store = tx.objectStore('OWS_tblOrderOverviewDelivered');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      store.clear();
      orderList.forEach((order: OrderInfoOverviewData) => {
        try {
          store.add(order);
        } catch (e: any) {
          if (e?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        }
      });
    });
  }

  markDeliveredOrderIndexDb(orderInfoHeaderID: number, userID: number): Promise<Object> {
    //mark as delivered in indexdb
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblOrderOverviewSubmitted', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderOverviewSubmitted');
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        store.get(orderInfoHeaderID).then(
          (order: OrderInfoOverviewData) => {
            order.isDelivered = true;
            order.orderStatusID = 16;
            order.wsStatus = "Delivered";
            order.wsStatusDesc = "Order delivered to ship";

            try {
              store.put(order);
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }

            resolve(order);
          });
      });
    });
    return promise;
  }

  updateSubmittedOrderInfoOverviewIndxDb(orderPayload: any): Promise<Object> {
    let promise = new Promise<any>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblOrderOverviewSubmitted', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderOverviewSubmitted');
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        let isRequestSubmitted = !isNaN(Number(orderPayload.orderInfoHeaderID.toString()));
        if (isRequestSubmitted) {
          store.get(Number(orderPayload.orderInfoHeaderID)).then(
            (res: OrderInfoOverviewData) => {
              if (res) {
                res.isUpdatedOffline = true;
                res.orderStatusID = orderPayload.statusID;
                res.wsStatus = orderPayload.statusDesc;
                res.wsStatusDesc = orderPayload.wsStatusDesc;

                try {
                  store.put(res).then((res2: any) => {
                    resolve(res2);
                  });
                } catch (e: any) {
                  if (e?.name === 'QuotaExceededError') {
                    this.handleQuotaExceeded();
                  }
                }

              } else {
                resolve(null);
              }
            });
        } else {
          resolve(null);
        }
      });
    });

    return promise;

  }

  deleteSubmittedOrderOverviewIndexDb(orderId: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblOrderOverviewSubmitted', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderOverviewSubmitted');
        store.get(parseInt(orderId.toString())).then((r: any) => {
          store.delete(parseInt(orderId.toString()));
          resolve(true);
        })
      })
    })
    return promise;
  }

  deleteOpenOrderInfoOverviewIndxDb(orderId: any): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblOrderOverviewOpen', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderOverviewOpen');
        store.get(parseInt(orderId)).then((r: any) => {
          store.delete(orderId);
          resolve(true);
        })
      })
    })
    return promise;
  }

  markDeletedOrderWSTempIndexDb(orderInfoHeaderID: number): Promise<Object> {
    //mark as delivered in indexdb
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        let tx = db.transaction('OWS_tblOrderOverviewOpen', 'readwrite');
        let store = tx.objectStore('OWS_tblOrderOverviewOpen');
        tx.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        tx.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        store.get(orderInfoHeaderID).then(
          (order: OrderInfoOverviewData) => {
            order.isUpdatedOffline = true;
            order.isTempDeleted = true;

            try {
              store.put(order);
            } catch (e: any) {
              if (e?.name === 'QuotaExceededError') {
                this.handleQuotaExceeded();
              }
            }

            resolve(order);
          });
      });
    });
    return promise;
  }

  handleQuotaExceeded() {
    swal
      .fire({
        title: 'Error',
        html: '<span>IndexedDB storage qouta exceeded.</span>',
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }
}
